<template>
  <div class="fastStart">
    <v-header />
    <div class="fastCon">
      <div class="fast-top">
        <img v-if="$i18n.locale === 'zh-CN'" src="./image/1946.png" />
        <img v-if="$i18n.locale === 'en-US'" src="./image/1946-US.png" />
      </div>
      <div class="fast-con">
        <div>
          <div class="fastCon-title">
            <img src="./image/STEP1.png" />
          </div>
          <div class="fastCon-Con">
            <div class="itemTitle">{{ data.setp1.title }}</div>
            <p v-for="item in data.setp1.list" :key="item">
              {{ item }}
            </p>
            <div class="itemImg">
              <img v-if="$i18n.locale === 'zh-CN'" src="./image/1950.png" />
              <img v-if="$i18n.locale === 'en-US'" src="./image/2695.png" />
            </div>
            <div v-if="$i18n.locale === 'en-US'" class="step1-US">
              <div>
                <img src="./image/5.png" />
                <div>
                  <p>1. Input your email address on the page.</p>
                  <p>
                    2. Please click the button “Get Verified“. A code will be
                    sent to your email box and you need to check and input the
                    code from your email box
                  </p>
                  <p>3. Please set a new password below.</p>
                  <p>4. Click the “Log in” button.</p>
                  <p>
                    5. Then use the email and new password to login the system.
                  </p>
                </div>
              </div>
              <div>
                <img src="./image/2695-2.png" />
                <div>
                  <p>1. Input your email which you just verified.</p>
                  <p>2. Input your new password.</p>
                  <p>3. Click “Log in” to enter our service.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="fastCon-title">
            <img src="./image/STEP2.png" />
          </div>
          <div class="fastCon-Con">
            <div class="itemTitle">{{ data.setp2.title }}</div>
            <p v-for="item in data.setp2.list" :key="item">
              {{ item }}
            </p>
            <div class="itemImg">
              <img v-if="$i18n.locale === 'zh-CN'" src="./image/1958.png" />
              <img v-if="$i18n.locale === 'en-US'" src="./image/2695-5.png" />
            </div>
          </div>
        </div>
        <div>
          <div class="fastCon-title">
            <img src="./image/STEP3.png" />
          </div>
          <div class="fastCon-Con">
            <div class="itemTitle">{{ data.setp3.title }}</div>
            <p v-for="item in data.setp3.list" :key="item">
              {{ item }}
            </p>
            <div v-if="$i18n.locale === 'zh-CN'" class="itemImg">
              <img src="./image/1958-3.png" />
              <img src="./image/1958-4.png" />
            </div>
            <div v-if="$i18n.locale === 'en-US'" class="itemImg">
              <img src="./image/2695-4.png" />
            </div>
          </div>
        </div>
        <div>
          <div class="fastCon-title">
            <img src="./image/STEP4.png" />
          </div>
          <div class="fastCon-Con">
            <div class="itemTitle">{{ data.setp4.title }}</div>
            <p v-for="item in data.setp4.list" :key="item">
              {{ item }}
            </p>
            <div class="itemImg">
              <img v-if="$i18n.locale === 'zh-CN'" src="./image/1958-5.png" />
              <img v-if="$i18n.locale === 'en-US'" src="./image/2695-6.png" />
            </div>
          </div>
        </div>
        <div>
          <div class="fastCon-title">
            <img src="./image/STEP5.png" />
          </div>
          <div class="fastCon-Con">
            <div class="itemTitle">{{ data.setp5.title }}</div>
            <p v-for="item in data.setp5.list" :key="item">
              {{ item }}
            </p>
            <div class="itemImg">
              <img v-if="$i18n.locale === 'zh-CN'" src="./image/1957.png" />
              <img v-if="$i18n.locale === 'en-US'" src="./image/2695-7.png" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-footer />
  </div>
</template>
<script>
import Header from '../home/components/header.vue';
import Footer from '../home/components/footer.vue';
export default {
  data() {
    return {
      data: {},
      dataUS: {
        setp1: {
          title: 'Sign up & Log in',
          list: [
            '1. If you are the first time visiting us, please click“Log in”and you will find the “sign up”button in another page.',
            'P.S : Currently for customers overseas, Phone verification is not avaliable. So please use E-mail to Sign up. ',
            '2. Then back to the “log in” TAB. Input your username and password to log in.',
          ],
        },
        setp2: {
          title: 'Create an order',
          list: [
            '1. Click “Instant Order” in the Menu on the left. Choose a service you want. ',
            '2. On the right side, you will find the service page. please fill in the information accordingly. e.g: Vendor info., Service date, Product spec., Requirement. ect. (Text boxes with “*”are required) ',
          ],
        },
        setp3: {
          title: 'Order confirmation & Get Quote',
          list: [
            '1. Click “Create the order”after all the text fields are filled and you can have a brief review of the order. click “OK” to confirm and your order will be created in the system.',
            '2. Our Staff will contact you to quote your order. (MD) ',
            '3. After that you can find your order in “My Order”-“Order List”. Click“Pay” to finish the payment.',
          ],
        },
        setp4: {
          title: 'Service',
          list: [
            '1. Our Inspection Engineer will contact the Factory/Vendor at once. All details such as location, due date, production status ect. will be double confirmed.',
            '2. The engineer will arrive at the assigned factory site to start the inspection. You can always get to know the inspection status simply by clicking“review”to check all details. ',
          ],
        },
        setp5: {
          title: 'Report audition & Release ',
          list: [
            '1. Our service team will create and audit the report after our engineer has finished the service. ',
            '2. You will be able to download the Final Report in “My Report”.',
            '3. Please evaluate and review the service in “My Review”.',
            '4. Feel free to contact our service team if you got any questions.',
          ],
        },
      },
      dataCN: {
        setp1: {
          title: '在线注册/登录',
          list: [
            '1. 新用户可在页面右上角 登录/注册 按钮中进行用户注册。',
            '2. 在登录界面使用已注册的用户名和密码进行账户登录',
          ],
        },
        setp2: {
          title: '填写并提交订单信息',
          list: [
            '1. 点击快速下单，选择对应服务项目。',
            '2. 在右边弹出的页面中跟据信息提示，完善公司/供应商信息，填写期望的服务时间地点，产品信息，检验要求等',
          ],
        },
        setp3: {
          title: '订单确认及报价',
          list: [
            '1. 在订单输入页面末端点击“提交订单”，并在弹出的页面中确认信息是否正确，确认无误后点击 “ok”生产订单 ',
            '2. 系统收到订单后，工作人员会主动联系客户确认订单所需的服务人天数。 ',
            '3. 确认后请在“我的订单”-“全部订单”中找到该订单并完成付款。',
          ],
        },
        setp4: {
          title: '执行检验任务',
          list: [
            '1. 曼德检验工程师在接到检验任务后会在第一时间与厂家取得联系，确认任务地点，时间，货品状态等信息。 ',
            '2. 检验任务当天，工程师会准时到达任务地点开始检验任务，检验过程中有任何情况均可随时通过订单列表中的“查看报告 ”功能来实时查看检验进度。',
          ],
        },
        setp5: {
          title: '报告验审及报告发布 ',
          list: [
            '1. 检验完成后，曼德将对检验工程师提交的报告进行细致的审核。 ',
            '2. 请通过订单列表中的查看报告功能收取/下载正式报告。 ',
            '3. 完成订单后请对该订单给予评价。 ',
            '4. 如有任何疑问，请联系客服人员。',
          ],
        },
      },
    };
  },
  created() {
    if (this.$i18n.locale === 'zh-CN') {
      this.data = this.dataCN;
    } else if (this.$i18n.locale === 'en-US') {
      this.data = this.dataUS;
    }
  },
  computed: {
    language: function() {
      return this.$i18n.locale;
    },
  },
  watch: {
    language: function() {
      if (this.$i18n.locale === 'zh-CN') {
        this.data = this.dataCN;
      } else if (this.$i18n.locale === 'en-US') {
        this.data = this.dataUS;
      }
    },
  },
  components: {
    'v-header': Header,
    'v-footer': Footer,
  },
};
</script>
<style lang="less">
.fastStart {
  .fast-con {
    text-align: left;
    margin: 20px 10%;
    .fastCon-Con {
      box-shadow: 0 0 10px 0px #999;
      padding: 50px 0;
      margin-bottom: 50px;
      .itemTitle {
        font-size: 20px;
        font-weight: 700;
        margin-left: 10%;
      }
      p {
        font-size: 20px;
        font-weight: 500;
        margin-bottom: 0;
        margin-left: 10%;
      }
      .itemImg {
        text-align: center;
        margin-top: 40px;
        img {
          max-width: 100%;
        }
      }
      .step1-US {
        display: flex;
        padding: 40px 10% 0;
        justify-content: space-around;
        > div {
          width: 40%;
          img {
            margin-bottom: 20px;
          }
          p {
            margin-left: 0;
            font-size: 16px;
          }
        }
      }
    }
  }
}
</style>
